// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import './Marketing.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getSubscriptionMeta } from '../config/subscriptions';

const Pricing = () => {
  const smsMeta = getSubscriptionMeta('sms');
  const callMeta = getSubscriptionMeta('call');
  const aiMeta = getSubscriptionMeta('ai');

  return (
    <>
      <Header />
      <div className="pricing-page">
        <h1 className="pricing-title">Simple, Transparent Pricing</h1>
        <div className="pricing-tiers">
          <div className="pricing-card">
            <h2>Free</h2>
            <p className="price">₹0<span>/mo</span></p>
            <ul>
              <li>Starter AI services</li>
              <li>Community support</li>
              <li>Up to 3 projects</li>
            </ul>
            <a href="/login" className="marketing-cta">Get Started</a>
          </div>
          <div className="pricing-card featured">
            <h2>Growth</h2>
            <p className="price">₹5<span>/mo</span></p>
            <ul>
              <li>All Free features</li>
              <li>Unlimited projects</li>
              <li>Priority support</li>
              <li>Advanced analytics</li>
              <li>{`AI Suite (${aiMeta.priceLabel})`}</li>
              <li>Workflow automations + webhooks</li>
              <li>Team collaboration (5 seats)</li>
              <li>Daily insights and alerts</li>
              <li>Role-based access controls</li>
            </ul>
            <a href="/login" className="marketing-cta">Start Growth</a>
          </div>
          <div className="pricing-card">
            <h2>Enterprise</h2>
            <p className="price">Custom</p>
            <ul>
              <li>All Growth features</li>
              <li>Dedicated account manager</li>
              <li>Custom integrations</li>
              <li>White-glove onboarding</li>
            </ul>
            <a href="/login" className="marketing-cta secondary">Contact Us</a>
          </div>
        </div>

        <div className="pricing-addons">
          <h3 className="pricing-subtitle">Add-ons priced for usage</h3>
          <div className="addon-grid">
            <div className="addon-card">
              <p className="addon-label">{smsMeta.label}</p>
              <h4 className="addon-price">{smsMeta.priceLabel}</h4>
              <p className="muted">Pay-as-you-go for sends and scheduling with the same gating used in the dashboard.</p>
            </div>
            <div className="addon-card">
              <p className="addon-label">{callMeta.label}</p>
              <h4 className="addon-price">{callMeta.priceLabel}</h4>
              <p className="muted">Calls and scheduled voice drops with subscription-aware access.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Pricing;
